export let hybridspaceWorkPlanLink = "uF0UFe";
export let hybridspaceDevPanelLink = "XZAtWd";
export let hybridspaceExplorePageLink = "GBOzNe";
export default {hybridspaceWorkPlanLink,hybridspaceDevPanelLink,hybridspaceExplorePageLink};